module.exports = __webpack_public_path__ + "static/media/stripe.dbee1aaf.png";